import React from 'react'
import { FAQPageJsonLd } from 'next-seo'
import { FiChevronDown } from '@react-icons/all-files/fi/FiChevronDown'
import Container from '../foundations/Container'
import styles from './FAQGroup.module.scss'

const FAQGroup = ({
  questions = [],
  title = 'Frequently Asked Questions',
  headingId = 'service-faq-title',
  eyebrow = 'Rental answers',
  intro = 'Clear answers about scheduling, pickup, delivery, setup, deposits, and equipment selection.',
  includeStructuredData = true
}) => {
  if (!questions.length) return null

  return (
    <section className={styles.section} aria-labelledby={headingId}>
      {includeStructuredData && <FAQPageJsonLd
        mainEntity={questions.map(question => ({
          questionName: question.question,
          acceptedAnswerText: question.answer
        }))}
      />}
      <Container className={styles.layout}>
        <div className={styles.heading}>
          {eyebrow && <span>{eyebrow}</span>}
          <h2 id={headingId}>{title}</h2>
          {intro && <p>{intro}</p>}
        </div>
        <div className={styles.questions}>
          {questions.map((question, index) => (
            <details key={question._id || question.question} open={index === 0}>
              <summary>
                <span>{question.question}</span>
                <FiChevronDown aria-hidden='true' />
              </summary>
              <div className={styles.answer}>
                <p>{question.answerContent || question.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default FAQGroup
